<template>
  <div class="d-flex" :class="[isVertical ? 'flex-column' : 'flex-row flex-wrap']" :data-exp-btn-row-id="rowId">
    <div
      v-for="(button, buttonIdx) of buttonOptions"
      :class="[{ 'me-1': isHorizontal }, { 'col-12 col-sm-6 col-md-12 col-lg-6': isCardView }]"
      :key="button.url"
    >
      <expanded-row-button :row-id="rowId" :button="button" :button-index="buttonIdx" />
    </div>
  </div>
</template>

<script>
import ExpandedRowButton from './ExpandedRowButton'
import { get } from 'lodash'

export default {
  name: 'ExpandedRowButtons',
  components: {
    ExpandedRowButton,
  },
  props: {
    rowId: {
      type: [Number, String],
    },
  },
  computed: {
    buttonOptions() {
      return get(this.rowOptions, 'functions', [])
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
    isDetailView() {
      return this.$get('viewMode') === 'detailView'
    },
    isGridView() {
      return this.$get('viewMode') === 'gridView'
    },
    isHorizontal() {
      return this.isDetailView || (this.isGridView && !this.showDetailView)
    },
    isVertical() {
      return this.isGridView && this.showDetailView
    },
    rowDetails() {
      return this.$get('rowDetails')
    },
    rowOptions() {
      return get(this.rowDetails, [this.rowId, 'options'], [])
    },
    showDetailView() {
      return this.$get('visibilityState')({ key: 'showDetailView' })
    },
    viewMode() {
      return this.$get('viewMode')
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
}
</script>

<style lang="scss" scoped>
.d-flex > div {
  padding: 0 2px;
}
</style>
